import Dropdown from "../Dropdown"
import Button from "./Button"
import ModelPartsDropdown from "./materials/ModelPartsDropdown"
import MaterialsDropdown from "./materials/MaterialsDropdown"
import DoorPositionDropdown from "./DoorPositionDropdown"
import { setSecurity,setActiveWall, setRoof, setDoor, setSelectedMainFeatureMenu,setWallConfigStates,configuratorState, setSelectedStructure,setSelectedMaterial,setSelectedModelPart, setCompleted, setCameraAngle,setSelectedPartRadioBtn, setShowForm, setInitialised, state, cameraState, setSaveImage} from "../../../state"
import { useEffect, useState } from "react"
import { useSnapshot } from "valtio"
import WarningScreen from "../../../WarningScreen"
import { ListAcordion } from "../ListAcordion"
import { Spherical, Vector3 } from "three"
import SaveImage from "../controls/SaveImage"

const SideSelector = () =>{
    const {selectedStructure, wallConfigStates, modelPartsSelectorStatus,selectedMaterial,selectedSecurity,wallStatus,selectedPartsMenu,completed} = useSnapshot(configuratorState);
    const [activeTab, setActiveTab] =useState([{name:"wall1", active:true},{name:"wall2", active:false},{name:"wall3", active:false},{name:"wall4", active:false},{name:"roof", active:false}]);

    const switchActive = (value) => {
        setCameraAngle(value==1?3:value==3?1:value)
        let prevTab;
        activeTab.forEach((tab,i) => {
            if(tab.active) prevTab = tab.name;
        })
        setWallConfigStates(prevTab,{structure: wallStatus[prevTab]?selectedStructure:undefined, finish:selectedMaterial, door:wallConfigStates[prevTab].door, security:selectedSecurity});
        const state = [{name:"wall1", active:false},{name:"wall2", active:false},{name:"wall3", active:false},{name:"wall4", active:false},{name:"roof", active:false}];
        state[value].active = true;
        setActiveTab(state);
        setActiveWall(activeTab[value].name)
    }

    useEffect(()=>{
        if(completed){
            switchActive(0);
            setShowForm(true);
            setCompleted(false)
        }
    },[completed])

    useEffect(()=>{
        let currentTab;
        activeTab.forEach((tab,i)=>{
            if(tab.active) currentTab = tab.name;
        })
        
        if(wallConfigStates[currentTab]){
            wallConfigStates[currentTab].structure?setSelectedStructure(wallConfigStates[currentTab].structure):setSelectedStructure(undefined);
            wallConfigStates[currentTab].door?setDoor(currentTab,wallConfigStates[currentTab].door):setDoor(currentTab,"none");
            wallConfigStates[currentTab].security?setSecurity(currentTab,wallConfigStates[currentTab].security):setSecurity(currentTab,undefined);
            
    
            if(wallConfigStates[currentTab].finish){
                wallConfigStates[currentTab].structure==="STL"?(setSelectedModelPart("H-Series Steel Panels")):null;
                wallConfigStates[currentTab].structure==="Freestyle-STL"?setSelectedModelPart("H-Series Freestyle Steel Panels"):null;
                wallConfigStates[currentTab].structure==="Zed"?setSelectedModelPart("H-Series Zed Panels"):null;
                wallConfigStates[currentTab].structure==="Horiz-Timber"?setSelectedModelPart("H-Series Wooden Panels"):null;
                wallConfigStates[currentTab].structure==="Vert-Timber"?setSelectedModelPart("H-Series Wooden Panels"):null;
                wallConfigStates[currentTab].structure==="TGV"?setSelectedModelPart("H-Series Wooden Panels"):null;
                setSelectedMaterial(wallConfigStates[currentTab].finish);
            }
            //else setSelectedMaterial(undefined)
        }
    },[activeTab, wallConfigStates])

    return(
        <div className="horizontal-options" id="tabs">
            <Button id="wall1Button" class="tabButton" value = {"Wall 1"} label = {"Wall 1"} primary = {activeTab[0].active} large ={false} onClick = {()=>switchActive(0)}/>
            <Button id="wall2Button" class="tabButton" value = {"Wall 2"} label = {"Wall 2"} primary = {activeTab[1].active} large ={false} onClick = {()=>switchActive(1)}/>
            <Button id="wall3Button" class="tabButton" value = {"Wall 3"} label = {"Wall 3"} primary = {activeTab[2].active} large ={false} onClick = {()=>switchActive(2)}/>
            <Button id="wall4Button" class="tabButton" value = {"Wall 4"} label = {"Wall 4"} primary = {activeTab[3].active} large ={false} onClick = {()=>switchActive(3)}/>
            <Button id="roofButton"  class="tabButton" value = {"Roof"} label = {"Roof"} primary = {activeTab[4].active} large ={false} onClick = {()=>switchActive(4)}/>
        </div>
    )
}

const SecuritySelector = () => {
    const {activeWall} = useSnapshot(configuratorState);
    
    return(
        <div className="horizontal-options-left">
            <Button leftAlign={true} id="security1Button" label = {"Latch + Code Secure Lock"}  image ={true} value={"digi"} primary = {false} large ={false} onClick={()=>setSecurity(activeWall,"Digi")}>
                <span style={{position: "absolute", top: "77.5%", color: "black", maxWidth: "81px", textAlign: "center", fontSize: "11px"}}>Latch + Code Secure Lock</span>
            </Button>
            <Button leftAlign={true} id="security2Button" label = {"Latch + Eurocylinder Lock"} image ={true} value={"eu"} primary = {false} large ={false} onClick={()=>setSecurity(activeWall,"EU")}>
                <span style={{position: "absolute", top: "77.5%", color: "black", maxWidth: "81px", textAlign: "center", fontSize: "11px"}}>Latch + Eurocylinder Lock</span>
            </Button>
        </div>
    )
}

const DetailsSelector = () => {
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => (isExpanded) => {
        console.log(expanded===panel)
      setExpanded(isExpanded ? panel===expanded?false: panel :  false);
    };
    const {wallConfigStates,activeWall,selectedStructure} = useSnapshot(configuratorState);
    const[toggle, setToggle] = useState([false,false,false,false,false])
    const[displayWarning, setDisplayWarning] = useState(false)
    const handleClick = (id) => {
        const temp = [false,false,false,false, false];
        temp[id] = true;
        setToggle(temp);
    }
    const checkStatus = () => {
        return (wallConfigStates["wall1"].structure&&
        wallConfigStates["wall3"].structure&&
        wallConfigStates["wall4"].structure&&
        wallConfigStates["wall2"].structure) && (wallConfigStates["wall1"].door!=="none"||
        wallConfigStates["wall3"].door!=="none"||
        wallConfigStates["wall4"].door!=="none"||
        wallConfigStates["wall2"].door!=="none")
    };

    return(
        <>
        <div className="horizontal-options">  
            <div className="details-options">
            {activeWall==="roof"?
            <> 
            <Dropdown primary={true} expandable={true} toggle={toggle[4]} handleClick={()=>handleClick(4)} label = {"Roof Type"} child={toggle[4]&&<RoofSelector/>}/>
            {/* <Dropdown primary={true} expandable={true} toggle={toggle[5]} handleClick={()=>handleClick(5)} label = {" Height"} child={toggle[5]&&<RoofHeightSelector/>}/> */}
            </>:null}
            {activeWall!=="roof"?<ListAcordion primary={true} expanded={expanded==="panel1"} toggle={()=>handleChange("panel1")} label = {"Wall Structure"}><ModelPartsDropdown/></ListAcordion>:null}
                {(wallConfigStates[activeWall].structure&&wallConfigStates[activeWall].structure!=="Glass"&&activeWall!=="roof")?
                <ListAcordion primary={true} expanded={expanded==="panel2"} toggle={()=>handleChange("panel2")} label = {"Wall Finish"}><MaterialsDropdown/></ListAcordion>:null}
                {wallConfigStates[activeWall].structure&&activeWall!=="roof"?
                <ListAcordion primary={true} expanded={expanded==="panel3"} toggle={()=>handleChange("panel3")} label = {"Door Orientation"}><DoorPositionDropdown/></ListAcordion>:null}
                {wallConfigStates[activeWall].door!=="none"?
                <ListAcordion primary={true} expanded={expanded==="panel4"} toggle={()=>handleChange("panel4")} label = {"Locking Systems"}><SecuritySelector/></ListAcordion>:null}
                {displayWarning?<WarningScreen onClick={()=>setDisplayWarning(false)}/>:null}
            </div>
        </div>
        <div style={{display:"flex", justifyContent:"space-between", marginTop:12, overflowY:"scroll"}}>   
            <Button id="restartButton" label = {"Restart"} halfParentWidth={true}  image ={false} value={"restartButton"} large ={false} confirm={false} onClick={()=>setInitialised(false)}/>
            <Button id="confirmButton" label = {"Confirm"} halfParentWidth={true}  image ={false} value={"confirmButton"} primary = {checkStatus()} large ={false} leftPadding={true}confirm={false} onClick={()=>checkStatus()?setCompleted(true):setDisplayWarning(true)}/>
        </div>
        </>
    )
}

const RoofSelector = () => {
    const {activeWall,modelPartsSelectorStatus,selectedPartsMenu} = useSnapshot(configuratorState);
    useEffect(()=>{
        setSelectedMainFeatureMenu("Roof Type");
    })
    const selectActive = (value) => {
        setRoof(activeWall,value);
        setSelectedPartRadioBtn(value);
      }
    return(
        <div className="horizontal-options-left">
            {selectedPartsMenu.map((value, index) => {
                return (
                    <Button 
                        leftAlign={true} 
                        id={`roof${index}button`} 
                        label = {value.title.replace('-', ' ')}  
                        image ={false} 
                        variableSize={true}
                        value={value.title} 
                        large ={false} 
                        onClick={()=>selectActive(value.title)}
                        selected={modelPartsSelectorStatus[value.title]===true}
                    />)
                }
            )}
        </div>
    )
}

const RoofHeightSelector = () => {
    const {selectedPartsMenu, modelPartsSelectorStatus} = useSnapshot(configuratorState);
    useEffect(()=>{
        setSelectedMainFeatureMenu("Roof Height");
    })
    const selectActive = (value) => {
        setSelectedPartRadioBtn(value);
      }
    return(
        <div className="horizontal-options-left">
             {selectedPartsMenu.map((value, index) => {
                return (
                    <Button 
                        leftAlign={true} 
                        id={`roof${index}Button`}
                        variableSize={true}
                        label = {value.title}  
                        image ={false} 
                        value={value.title} 
                        large ={false} 
                        onClick={()=>{selectActive(value.title)}}
                        selected={modelPartsSelectorStatus[value.title]===true}
                    />
                )}
            )}
        </div>
    )
}

const PostConfigOptionSelector = (props) => {
    
    return(
        <div className="horizontal-options" style={{overflowY:"scroll"}}>
            {/* <Button id="dowloadSpec" class="tabButton" value = {"Download Spec"} label = {"Download Spec"} primary = {props.choice==0} large = {false} halfParentWidth={true} rightPadding={true} onClick = {()=>props.setChoice(0)}/> */}
            {/* <Button id="getQuote" class="tabButton postConfig" value = {"Get a Quote"} label = {"Get a Quote"} primary = {props.choice==1} large ={false} halfParentWidth={true} leftPadding={true} onClick = {()=>props.setChoice(1)}/> */}
        </div>
    )
}
const FormInput = (props) => {
    const [value, setValue] = useState("")
    useEffect(()=>{
       setValue(props.data)  
    },[props.data])
    return(
            <div className="form-input configurator-button-primary configurator-dropdown">
                <span>{`${props.id}*`}</span>
                <input className="large-input" id={props.id} value={value} onChange={(e)=>props.updateData(e.target.value)}></input>
            </div>
    ) 
}  

const PostConfigForm = (props) => {

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [formData, setFormData] = useState(undefined)
    const checkStatus = () => {
        return null;
    }

    useEffect(()=>{
        const temp={name, email, phone};
        setFormData(temp);
    },[name,email,phone])

    return(
        <div className="details-options">
            <FormInput data={name} updateData={setName} id={"Name"}/>
            <FormInput data={email} updateData={setEmail} id={"Email"}/>
            <FormInput data={phone} updateData={setPhone} id={"Phone"}/>
            <div className="horizontal-options">
            <Button id="backButton" label = {"Back"} image ={false} value={"backButton"} large ={false} confirm={true} halfParentWidth={true} rightPadding={true} onClick={()=>setShowForm(false)}/>
            <Button id="submitButton" label = {"Submit"} image ={false} value={"submitButton"} primary = {checkStatus()} large ={false} halfParentWidth={true} leftPadding={true} confirm={true} onClick={()=>props.submitData(formData)}/>
            </div>
        </div>
    )
}

const Options = () => {
    const {showForm, wallConfigStates} = useSnapshot(configuratorState);
    const [choice, setChoice] = useState(0);
    
    const submitData = (data) => {
        console.log("Form submitted");
        setSaveImage();
    }
    
    return(
        !showForm? 
        <div id="options">      
                <SideSelector/>
                <DetailsSelector/>
            </div>
            :
            <div id="options">      
                <PostConfigOptionSelector setChoice={setChoice} choice ={choice}/>
                <PostConfigForm submitData = {submitData}/>
            </div>
    )
}

export default Options;